import {LoaderStatus} from "./service/loaderStatus";
import {Loader} from "./component/loader";
import {LOADER_MODULE} from "./loaderModuleConfiguration";

LOADER_MODULE
    .createNewModule()
    .component('loader', Loader.instance)
    .service('LoaderStatusValue', LoaderStatus);

